import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CallToAction = ({ title }) => {
  const navigate = useNavigate();

  const handleSpeakersClick = () => {
    navigate('/contact');
  };

  return (
    <Box
      sx={{
        position: 'relative',
        background: 'linear-gradient(to bottom, #000000 0%, #232323 10%, #232323 90%, #000000 100%)',
        color: 'white',
        py: 8,
        px: 4,
        textAlign: 'center',
        borderTop: '1px solid #333',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("/speaking-audience.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(3px) brightness(0.3)',
          zIndex: 1,
        },
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 'var(--weight-extrabold)',
            mb: 3,
            color: 'white',
          }}
        >
          {title}
        </Typography>
        
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'var(--font-body)',
            maxWidth: '600px',
            mx: 'auto',
            mb: 4,
            color: '#cccccc',
            lineHeight: 1.6,
          }}
        >
          Connect with business leaders who will inspire 
           and elevate your audience to new heights.
        </Typography>
        
        <Button
          variant="contained"
          size="large"
          onClick={handleSpeakersClick}
          sx={{
            backgroundColor: 'white',
            color: 'black',
            fontFamily: 'var(--font-heading)',
            fontWeight: 'var(--weight-semibold)',
            px: 4,
            py: 1.5,
            fontSize: { xs: '1rem', md: '1.2rem' }, // Smaller font size on mobile
            borderRadius: '8px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#f0f0f0',
            },
          }}
        >
          Find the Perfect Speaker {'>'}
        </Button>
      </Box>
    </Box>
  );
};

export default CallToAction;
